import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import { Routes, routes } from "../../routes";
import PlayerBitmovin from "../../pages/PlayerBitmovin";
import { withAppState } from "../../state";
import { isAccessLimitedByParentalLevel } from "../../services/parentalControlService";

const Main = ({ initialFocus, onRef, setFocus, pauseNavigation, resumeNavigation, logger,from }) => {
  // FIXME: check whether sUC is needed.
  return (
    <Switch>
      {Routes.pages.map(page => {
        const Component = page.component;
        return (
          <Route
            exact={
              page.route === routes.splash ||
              page.route === routes.series ||
              page.route === `${routes.series}/:titleId` ||
              page.route === `${routes.series}/:titleId/episodes`
            }
            key={page.name}
            path={page.route}
            render={routeProps =>
              !isAccessLimitedByParentalLevel() || page.kidsAllowed ? (
                <Component
                  {...routeProps}
                  {...page}
                  initialFocus={initialFocus}
                  setFocus={setFocus}
                from={from}
                  pauseNavigation={pauseNavigation}
                  resumeNavigation={resumeNavigation}
                  onRef={onRef}
                  logger={logger}
                />
              ) : (
                <Redirect to={{ pathname: routes.kids }} />
              )
            }
          />
        );
      })}
      <Route
        exact
        key="player"
        path={routes.player}
        render={props => (
          <PlayerBitmovin
            {...props}
            setFocus={setFocus}
            pauseNavigation={pauseNavigation}
            resumeNavigation={resumeNavigation}
            onRef={onRef}
          />
        )}
      />
    </Switch>
  );
};

export default withAppState(Main);
